
import {MenuItem, Typography} from "@material-ui/core";
import React, {useState}  from "react";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import {renderMilisecondsToTimeDuration} from "../../../utils/datetimehelp";
import {getOrdensParaCorte, patchOSE, postCortePrintEtiqueta} from "../../../actions/orderActions";
import {useDispatch} from "react-redux";
import Button from "@material-ui/core/Button/Button";
import Menu from "@material-ui/core/Menu/Menu";
// import Button from "@material-ui/core/Button";
// import Menu from '@material-ui/core/Menu';
// import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles(theme => ({
    gridExterno: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'nowrap',
        flexGrow: 12,
        backgroundColor: 'white',
        margin: '6px',
        borderRadius: '15px',
        minHeight: '180px'
    },
    mainGrid: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 12,
        alignSelf: 'stretch',
        cursor: 'pointer'
    },

    nomeEtapa: {
        //backgroundColor: 'red',
        flex:1,
        justifyContent: 'center',
        borderBottom: '1px solid red'
    },
    valoresArea: {
        //  backgroundColor: 'green'
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    fila: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    concluidos: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    }

}));

const CorteOSGrid = (props) => {
    const classes = useStyles();
    const { ordemServico } = props;
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };



    const  dialog = async (os) => {
        if (os.resultado === 0) {
            window.scrollTo({top: 0, behavior: 'smooth'});
            props.cbOpenCorte(os, true);
        }
    }

    const  handleCancelarBanda = ( ) => {
        dispatch(patchOSE(ordemServico.oseId, {resultado: 3}));
        dispatch(getOrdensParaCorte());
        setAnchorEl(null);
    }

    const  etiqueta = async (os) => {
        if (os.resultado === 0) {

        } else {
            const x = await dispatch(postCortePrintEtiqueta(ordemServico, ordemServico.validacao));
        }
    }


    const tchegada = (new Date(new Date().getTime() - new Date(ordemServico.DTChegada).getTime()) );
    let bgC = 'white';
    switch (ordemServico.resultado) {
        case 2:
            bgC = 'green';
            break
        case 4:
            bgC = 'orange'
            break;
    }

    return (
        <React.Fragment>
            <Grid item container className={classes.gridExterno} style={{backgroundColor: bgC}}  xs={3} sm={3} md={3} lg={3} xl={3}>
                <Grid container item className={classes.mainGrid} onClick={() => dialog(ordemServico)} xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid item container className={classes.nomeEtapa} xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid item container className={classes.tituloGrid} style={{justifyContent: 'center'}} sm={11} md={11} lg={11} xl={11}>
                            <Typography variant="h4">{ordemServico.os.toUpperCase()}</Typography>
                        </Grid>
                        <Grid item container className={classes.tituloGrid} sm={1} md={1} lg={1} xl={1}>
                            <div>
                                <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                                    +
                                </Button>
                                <Menu
                                    id="simple-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                >
                                    <MenuItem onClick={handleCancelarBanda}>CANCELAR BANDA</MenuItem>
                                </Menu>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container item className={classes.valoresArea} xs={12} sm={12} md={12} lg={12} xl={12}>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>BANDA</Typography>
                            <Typography  style={{fontSize: '1.1rem'}}>{ordemServico.banda}</Typography>
                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>LARGURA</Typography>
                            <Typography  style={{fontSize: '1.1rem'}}>{ordemServico.largura}</Typography>
                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>COMPRIMENTO:</Typography>
                            <Typography  style={{fontSize: '1.1rem'}}>{ordemServico.perimetro}</Typography>
                        </ListItem>
                        <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                            <Typography  style={{fontSize: '0.8rem'}}>IDADE:</Typography>
                            <Typography  style={{fontSize: '1.1rem'}}>{renderMilisecondsToTimeDuration(tchegada)}</Typography>
                        </ListItem>

                        {  ordemServico.resultado === 2 &&
                            <React.Fragment>
                                <ListItem style={{display:'flex', justifyContent:'space-between'}} onClick={() => etiqueta(ordemServico)}>
                                    <Typography  style={{fontSize: '0.8rem'}}>VALIDACAO</Typography>
                                    <Typography  style={{fontSize: '1.1rem'}}>{ordemServico.validacao}</Typography>
                                </ListItem>
                            </React.Fragment>

                        }


                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    )

}

export default CorteOSGrid;
